import type { PeopleFilterState } from './people-filter-drawer';

const STORAGE_KEY = 'tabita.people.savedSearches.v1';

export interface SavedSearch {
  readonly id: string;
  readonly name: string;
  readonly filters: PeopleFilterState;
}

/**
 * Named filter presets, kept in `localStorage`.
 *
 * Per-browser, not per-tenant: there is no backend concept of a saved
 * search, so this is a convenience for the person using this device, not a
 * shared team resource. It does not sync across staff or devices.
 */
export function listSavedSearches(): readonly SavedSearch[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as SavedSearch[]) : [];
  } catch {
    return [];
  }
}

export function saveSearch(name: string, filters: PeopleFilterState): void {
  const existing = listSavedSearches();
  const next = [...existing, { id: crypto.randomUUID(), name, filters }];
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export function deleteSavedSearch(id: string): void {
  const next = listSavedSearches().filter((search) => search.id !== id);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}
